import {
  AsyncComponent,
  ConfiguredComponents,
} from '@r-and-a-shared-ui/core-component-config';
import type { PlayerPortalsPageProps } from './types';

import styles from './PlayerPortalsPage.module.scss';
import { PlayerPortalRestrictedContent } from '../PlayerPortalRestrictedContent/PlayerPortalRestrictedContent';
import { extractRolesNameFromItem } from '@r-and-a-shared-ui/auth-client';

export const PlayerPortalsBodyContent = ({
  body,
  sidebar,
}: Pick<PlayerPortalsPageProps, 'body' | 'sidebar'>) => {
  return (
    <div className={styles.container}>
      <div data-testid={'body-content'} className={styles.content}>
        <div className={styles.main}>
          {body.map(item => {
            const componentRoles = extractRolesNameFromItem(
              item.elements?.roles?.value,
            );

            return (
              <PlayerPortalRestrictedContent
                key={item.system.id}
                accessRestrictions={{
                  componentRoles: componentRoles.length
                    ? { required: componentRoles }
                    : undefined,
                }}
              >
                <AsyncComponent
                  kontentItem={item}
                  contentType={item.system.type as ConfiguredComponents}
                />
              </PlayerPortalRestrictedContent>
            );
          })}
        </div>
        <aside className={styles.sidebar} role="complementary">
          {sidebar
            .map(x => {
              const componentRoles = extractRolesNameFromItem(
                x.elements?.roles?.value,
              );
              return (
                <PlayerPortalRestrictedContent
                  key={x.system.id}
                  accessRestrictions={{
                    componentRoles: componentRoles.length
                      ? { required: componentRoles }
                      : undefined,
                  }}
                >
                  <AsyncComponent
                    kontentItem={x}
                    contentType={x.system.type as ConfiguredComponents}
                    key={x.system.id}
                  />
                </PlayerPortalRestrictedContent>
              );
            })
            .filter(Boolean)}
        </aside>
      </div>
    </div>
  );
};
